import React from 'react';
import ReactDOM from 'react-dom';
import Player from './player';

ReactDOM.render(<Player>
    <Player>
        <Player />
        <Player />
        <Player />
    </Player>
    <Player />
</Player>, document.querySelector('#playground'));
